/** Studio overview dashboard group (canonical `x_xwoe-E`). One read populates
 *  the whole page; do NOT hit the per-entity list endpoints and count
 *  client-side. The contract is frozen (see the build brief). */

import { api } from "./client";
import type { DashboardSummary, DashboardSummaryFilters } from "@/types";

/** GET /dashboard/summary — the entire Studio overview in one call. */
export function getDashboardSummary(filters: DashboardSummaryFilters = {}): Promise<DashboardSummary> {
  return api.get<DashboardSummary>("dashboard", "dashboard/summary", {
    query: {
      trend_months: filters.trend_months,
      tracker_limit: filters.tracker_limit,
    },
  });
}
